module.exports = __webpack_public_path__ + "media/src/images/icons/column_chart-bfcebd63dbdaae4498ff4ad0c6a22cef.svg";